export const SUPPORTED_LANGS = ["pt", "it", "es", "en"];

/**
 * Extrai o código de idioma do início do pathname (ex.: "/pt/shop" → "pt").
 * Retorna null se não houver prefixo de idioma suportado.
 */
export function detectLangFromPath(pathname = window.location.pathname) {
  const match = pathname.match(/^\/(pt|it|es|en)(\/|$)/);
  return match ? match[1] : null;
}

/**
 * Retorna o basename do BrowserRouter baseado no idioma presente na URL.
 * Ex.: "/pt/shop" → "/pt" | "/shop" → ""
 */
export function getLangBasename(pathname = window.location.pathname) {
  const lang = detectLangFromPath(pathname);

  return lang ? `/${lang}` : "";
}

/**
 * Remove o prefixo de idioma de um pathname.
 * Ex.: "/pt/shop" → "/shop" | "/shop" → "/shop"
 */
export function stripLangFromPath(pathname = window.location.pathname) {
  return pathname.replace(/^\/(pt|it|es|en)(\/|$)/, "/");
}
